import { useState } from "react";
import { useCurrency } from "@/lib/CurrencyProvider";
import { ChevronDown, Globe } from "lucide-react";

export default function CurrencySwitcher({ compact }) {
  const { code, list, changeCurrency, ready } = useCurrency();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  if (!ready) return null;
  const filtered = q ? list.filter((c) => c.code.includes(q.toUpperCase()) || c.name.toLowerCase().includes(q.toLowerCase())) : list;

  return (
    <div className="relative" data-testid="currency-switcher">
      <button onClick={() => setOpen(!open)} data-testid="currency-btn"
        className={`inline-flex items-center gap-1 rounded-full border border-[#EAD9B0] bg-white hover:border-[#0F766E] transition-colors ${compact ? "px-2.5 py-1.5 text-xs" : "px-3 py-2 text-xs"}`}>
        <Globe size={13} className="text-[#0F766E]" /> <span className="font-semibold">{code}</span> <ChevronDown size={12} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-64 max-h-80 overflow-hidden bg-white border border-[#EAD9B0] rounded-2xl shadow-2xl z-50" data-testid="currency-list">
            <div className="p-2 border-b border-[#EAD9B0]">
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search currency…"
                className="w-full px-3 py-1.5 rounded-lg bg-[#FFF7E6] border border-[#EAD9B0] text-xs focus:outline-none focus:ring-2 focus:ring-[#0F766E]"
                data-testid="currency-search" />
            </div>
            <div className="max-h-64 overflow-y-auto">
              {filtered.slice(0, 200).map((c) => (
                <button key={c.code} onClick={() => { changeCurrency(c.code); setOpen(false); setQ(""); }}
                  data-testid={`currency-opt-${c.code}`}
                  className={`w-full text-left px-3 py-2 text-xs flex justify-between items-center hover:bg-[#FFF7E6] ${code === c.code ? "bg-[#0F766E]/10 font-semibold" : ""}`}>
                  <span>{c.code} <span className="text-[#57534E] font-normal">{c.name}</span></span>
                  {c.popular && <span className="text-[9px] uppercase tracking-widest text-[#D4A017]">popular</span>}
                </button>
              ))}
              {filtered.length === 0 && <p className="p-3 text-xs text-[#57534E]">No matches</p>}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
